import { useAuth0 } from "@auth0/auth0-react";
import { Box } from "@mui/material";
import ServiceProvider from "../../../site/configuration/ServiceProvider";

const Auth0Logout: React.FC<React.PropsWithChildren<any>> = (
  props: React.PropsWithChildren<any>
) => {
  const { logout } = useAuth0();

  return (
    <Box
      onClick={() => {
        ServiceProvider.System.logout();
        setTimeout(() => {
          console.log("logout");
          logout({ logoutParams: { returnTo: window.location.origin } });
        }, 1000);
        
      }}
    >
      {props.children}
    </Box>
  );
};
export default Auth0Logout;
